import PageHero from "../components/PageHero";
import Properties from "../components/sections/Properties";
import SiteVisitCTA from "../components/sections/SiteVisitCTA";

export default function PropertiesPage({ onOpenLead }) {
  return (
    <div data-testid="properties-page">
      <PageHero
        eyebrow="Live Listings"
        title="Verified properties in Dholera."
        subtitle="Filter by type, category and budget — every plot is RERA-verified and title-clear."
        image="https://images.unsplash.com/photo-1613490908677-22920f5c1d63?q=80&w=2070&auto=format&fit=crop"
      />
      <Properties onOpenLead={onOpenLead} />
      <SiteVisitCTA />
    </div>
  );
}
